import React from "react";
import { View } from '../../../components/templates/View';
import { CDSeguridadPerimetral, CMSeguridadPerimetral } from '../organisms';
import { useViewport } from "../../../hooks";

const SeguridadPerimetral = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDSeguridadPerimetral /> }/>
            </>
        :
            <>
                <View children={ <CMSeguridadPerimetral/> }/>
            </>
    );
}

export default SeguridadPerimetral;

